<template>
    <transition name="coll-2" mode="in-out">
        <div
            v-show="showFilters"
            class="coll-2"
            :class="{ collId: true, 'visibility': showFilters == true }"
        >

            <div class="filter-head">
                <span class="filter-icon">
                    <i class="fal fa-sliders-h" />
                </span>

                <div class="title-subtitle">
                    <div class="title">
                        Personalizar
                    </div>

                    <div class="subtitle">
                        {{ reportTitle }}
                    </div>
                </div>

                <button class="button-close" type="button" @click="closeFilters">
                    <i class="fal fa-times" />
                </button>
            </div>

            <section class="filter-body scroll-color">

                <section class="filter-body-date-picker">
                    <ui-select-v2
                        v-model="form.data.general_field[reportCardIndex]"
                        :data="generalFieldOptions"
                        :show-apply-button="false"
                        open-event="general"
                        label="Selecionar colunas de Campos Gerais"
                        tooltip-text="Campos Padrões do Sistema."
                        apply-button="Selecionar"
                        return-value="alias"
                        tooltip
                        multiple
                        @input="generalFieldsHandler"
                    />

                    <ui-select-v2
                        v-model="form.data.custom_field[reportCardIndex]"
                        :data="customFieldOptions"
                        :show-apply-button="false"
                        group-by="group"
                        return-value="object"
                        label="Selecionar colunas de Campos Personalizados"
                        tooltip-text="Campos Personalizados do Sistema."
                        apply-button="Selecionar"
                        tooltip
                        multiple
                        @input="customFieldsHandler"
                    />
                </section>
                <div class="filter-body-select">

                    <div v-for="(item, index) in filterOptions" :key="index">
                        <ui-date-range
                            v-if="item.component === 'datepicker-range' && !item.hidden"
                            v-model="form.data.date_range[reportCardIndex][item.name]"
                            :label="item.label"
                            :name="item.name"
                            :hide-options="['Hoje', 'Todos']"
                            :max-date="hasWithoutInstances ? item.maxDate : newMaxDate"
                            :same-or-upper-today="hasWithoutInstances ? false : true"
                            class="date-range"
                            size="md"
                            @selected="selectedHandler"
                        />

                        <ui-select-v2
                            v-if="item.component !== 'datepicker-range'"
                            v-model="form.data.filters_data[reportCardIndex][item.name]"
                            class="select-filters"
                            :data="item.options"
                            :label="`Filtrar dados de ${item.label}`"
                            :open-event="item.method"
                            :loading="item.loading"
                            :multiple="item.multiple"
                            :item-label="item.itemLabel"
                            :show-apply-button="false"
                            :return-value="item.returnValue"
                            :disabled="item.disabled"
                            tooltip-text="Filtre as informações que você deseja trazer no seu relatório"
                            tooltip
                            apply-button="Selecionar"
                            @input="call(item.handler, $event)"
                        />

                        <ui-filters
                            v-if="item.component !== 'datepicker-range'"
                            :method="item.method"
                            :filters="item"
                            :index="index"
                            :data="item.options"
                            @clicked="clickHandler"
                        />
                    </div>
                </div>
            </section>

            <div class="filter-footer">
                <div v-if="cvsXlsx" class="filter-footer-buttons-csv-xlsx">
                    <div class="filter-footer-csv">
                        <ui-button type="submit" design="md primary mw-150">
                            Baixar CSV
                        </ui-button>
                    </div>

                    <div class="filter-footer-xlsx">
                        <ui-button type="submit" design="md success mw-150">
                            Gerar XLSX
                        </ui-button>
                    </div>
                </div>

                <div v-else class="filter-footer-generate-reports">
                    <ui-button design="md primary mw-300" type="button" :disabled="disable" @click="openGenerateReportsModal">
                        Gerar relatório
                    </ui-button>

                    <span class="filter-footer-generate-reports-wipe-data" @click="clearFields">
                        Limpar campos
                    </span>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { uiFilters } from '@/components/ui'
import { uiButton } from "@/components/ui/buttons"
import { uiDateRange, uiSelectV2 } from '@/components/ui/form'

import { activeOffer, reportsCategory, team } from '@/services/axios'

import { storage } from '@/services/storage'

import { helpersMixin, utilMixin } from '@/mixins'

import { defaultFilters } from '@/assets/js/data.js'

import { mapGetters } from 'vuex'

const moment = require('moment')
require('moment/locale/pt-br')

export default {
    name: 'ui-reports-side-menu-right',

    components: {
        uiButton,
        uiSelectV2,
        uiDateRange,
        uiFilters
    },

    mixins: [helpersMixin, utilMixin],

    data() {
        return {
            form: {
                data: {
                    general_field: [],
                    custom_field: [],
                    filters_data: [],
                    date_range: []
                },
                fields: {
                    general_field: {},
                }
            },
            showFilters: false,
            cvsXlsx: false,
            generalFieldOptions: [],
            customFieldOptions: [],
            filterOptions: [],
            disable: true,
            reportCardIndex: null,
            reportCardCategory: null,
            allFilters: [...defaultFilters()], // recebe todos os arquivos do data.js
            fieldName: null,
            fieldsSelected: {},
            filters: {},
            fileName: '',
            reportFilters: [],
            reportTitle: '',
            hasWithoutInstances: false,
            newMaxDate: null
        }
    },

    computed: {
        ...mapGetters('auth', {
            user: 'getUser'
        }),
    },

    async created() {
        this.$root.$on('select-v2-open-event-general', () => {
            this.clickHandler('general')
        })

        this.$root.$on('report-title', title => {
            this.reportTitle = title
        })

        this.$root.$on('show-filters', (generalFields, customFields, filters, category, index) => {
            this.reportCardIndex = index
            this.reportCardCategory = category
            this.generalFieldOptions = [...generalFields]
            this.loadCustomFields(customFields)
            this.loadFilters(filters)
            this.loadStorage()
            this.showFilters = true
        })

        this.$root.$on('set-new-reports', () => {
            this.closeFilters()
        })

        const getStorageInstance = JSON.parse(storage.get('api_config'))
        const withInstance = getStorageInstance.instance
        try {
            const response = await reportsCategory.getWithoutInstances()
            this.hasWithoutInstances = response.withoutInstances.includes(withInstance)
            this.newMaxDate = moment().subtract(0 , 'days').format('YYYY-MM-DD')
        } catch (error) {
            console.error(error)
        }
    },

    beforeDestroy() {
        this.$root.$off('select-v2-open-event-general')
        this.$root.$off('show-filters')
        this.$root.$off('set-new-reports')
    },

    methods: {
        /**
         * Carrega as opções de campos customizados
         */
        loadCustomFields(customFields) {
            this.customFieldOptions = Object.values(customFields)
                .map(customField => {
                    return Object.keys(customField)
                        .map(group => {
                            return customField[group].map(field => {
                                field.group = group
                                field.value = `${group}:${field.id}`
                                return field
                            })
                        })
                        .reduce((accumulated, element) => {
                            return accumulated.concat(element)
                        }, [])
                })
                .reduce((accumulated, element) => {
                    return accumulated.concat(element)
                }, [])
        },
        /**
         * Carrega as opções de filtro definidas para o relatório
         */
        loadFilters(filters) {
            const filterLabels = filters.map(filter => filter.label)
            this.filterOptions = this.allFilters.filter(item => filterLabels.includes(item.label))
            // Inicializa as variaveis do v-model dos campos dinamicos
            this.form.data.filters_data[this.reportCardIndex] = {}
            this.form.data.date_range[this.reportCardIndex] = {}

            // Carrega as opções dos filtros e seta seus valores iniciais
            for (const filter of this.filterOptions) {
                const group = filter.component === 'datepicker-range' ? 'date_range' : 'filters_data'
                let value = null
                if (filter.preSelected && filter.preSelected.includes('reports')) {
                    const startDate = moment().subtract(30, 'd').format('YYYY-MM-DD')
                    const endDate = moment().format('YYYY-MM-DD')
                    value = `${startDate}_${endDate}`
                }
                this.form.data[group][this.reportCardIndex][filter.name] = value
                if (filter.params.name === 'queue_id') {
                    filter.serviceParams = [this.user.id]

                    /**
                     * Caso não haja nenhuma seleção prévia para o filtro de filas de Oferta Ativa,
                     * desabilita o filtro de Reação
                     */
                    if (!filter.params.value) {
                        const reasonsFilter = this.filterOptions.find(filter => filter.params.name === 'reasons_id')
                        reasonsFilter.disabled = true
                    }
                }

                if (filter.service && filter.requestOnStart && !filter.alreadyRequested) {
                    this.responseFiltersData(filter)
                }
            }
        },
        /**
         * Carrega os dados necessários para as opções de um filtro via requisição
         * AJAX
         */
        responseFiltersData(filter) {
            (() => import('@/services/axios/modules/'+ filter.service + '.js'))().then(service => {
                const api = service.default.build()
                let params = ['']
                if (filter.serviceParams) params = [...filter.serviceParams]

                api[filter.method](...params).then(response => {
                    let data = []
                    /** Verifica se a requisição retornou uma paginação */
                    // eslint-disable-next-line no-prototype-builtins
                    if (response.data.hasOwnProperty('total')) {
                        data = [...response.data.data]

                    /** Verifica se a requisição retornou um array */
                    // eslint-disable-next-line no-prototype-builtins
                    } else if (response.data.hasOwnProperty('length')) {
                        data = [...response.data]

                    /** Se nenhum dos outros casos for atendido, trata o retorno como um objeto */
                    } else if (typeof response.data === 'object') {
                        data = { ...response.data }
                    }

                    /** Verifica se os resultados necessitam ser formatados */
                    if (filter.parse) {
                        filter.options = filter.parse(data)
                    } else {
                        filter.options = Object.values(data)
                    }
                })

                filter.alreadyRequested = true
            }).catch(error => {
                if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                console.log(error)
            })
        },
        /**
         * Carrega os dados salvos na localStorage dos campos gerais, personalisados e filtros dinamicos
         */
        loadStorage() {
            const storageData = storage.get(`${this.reportCardCategory}_card_fields_${this.reportCardIndex}`)
            let data = []
            if (storageData && this.isJSON(storageData)) data = JSON.parse(storageData)
            let totalFields = 0

            for (const item of data) {
                totalFields += item.fields?.length

                switch (item.fieldName) {
                    case 'general':
                    case 'customFields':
                        var fieldGroup = item.fieldName === 'general' ? 'general_field' : 'custom_field'
                        this.form.data[fieldGroup][this.reportCardIndex] = [...item.fields]
                        break

                    default:
                        var filter =  this.filterOptions.find(option => option.name === item.fieldName)
                        if (filter) this.loadFilterDefault(filter, item)
                        break
                }
            }

            this.disable = !totalFields
            this.fieldsSelected[this.reportCardIndex] = data
        },
        /**
         * Carrega as seleções para os filtros salvos no localStorage
         */
        loadFilterDefault(filter, item) {
            let filterGroup = filter.component === 'datepicker-range' ? 'date_range' : 'filters_data'
            this.form.data[filterGroup][this.reportCardIndex][item.fieldName] = filter.multiple
                ? [...item.fields]
                : item.fields[0]

            if (item.fieldName === 'equipe') {
                this.teamHandler(this.form.data.filters_data[this.reportCardIndex][item.fieldName])

            } else if (item.fieldName === 'etapa') {
                this.stageHandler(this.form.data.filters_data[this.reportCardIndex][item.fieldName])
            }
        },
        /**
         * Fecha o menu com as opções de filtros e campos customizados e gerais
         */
        closeFilters() {
            this.clearForm()
            this.showFilters = false
            this.$root.$emit('close-filters', this.showFilters)
        },
        /**
         * Solicita a abertura do modal para a geração e download do contrato
         */
        openGenerateReportsModal() {
            this.$gtm.trackEvent({
                event: "fac_button_click",
                category: "vue-relatorio-planilhas-new",
                action: "click",
                label: "Gerar Relatório - Abre modal"
            })

            this.generateReport()
            this.closeFilters()
        },
        /**
         * Executado quando usuário escolhe campos em 'Campos Gerais'
         * e 'Filtros de Dados' (dinâmicos)
         */
        inputHandler(fields) {
            const fieldName = this.fieldName
            const newObj = {
                fieldName,
                fields
            }
            let indexFound = null
            let selectedFields = this.fieldsSelected[this.reportCardIndex] || []

            // Verifica se campo atual já foi selecionado
            // e mostra o índice do campo encontrado para posterior alteração
            const existingFields = selectedFields.filter((item, index) => {
                if (item.fieldName === fieldName) {
                    indexFound = index
                    return true
                }
                return false
            })

            if (existingFields?.length) {
                this.fieldsSelected[this.reportCardIndex][indexFound] = newObj // Alterar campo ja selecionado
            } else {
                selectedFields.push(newObj)
                this.fieldsSelected[this.reportCardIndex] = selectedFields // Insere campo selecionado
            }

            const fnReduce = (acm, current) => current?.fields?.length + acm

            const totalFields = this.fieldsSelected[this.reportCardIndex]?.reduce(fnReduce, 0)
            this.disable = totalFields < 1
        },

        /**
         * Event handler que trata o evento de quando um grupo campo customizado
         */
        generalFieldsHandler(fields) {
            this.$gtm.trackEvent({
                event: "fac_button_click",
                category: "vue-relatorio-planilhas-new",
                action: "click",
                label: "Selecionar colunas de Campos Gerais"
            })

            this.clickHandler('general')
            this.inputHandler(fields)
        },
        /**
         * Event handler que trata o evento de quando um grupo campo customizado
         */
        customFieldsHandler(fields) {
            this.$gtm.trackEvent({
                event: "fac_button_click",
                category: "vue-relatorio-planilhas-new",
                action: "click",
                label: "Selecionar colunas de Campos Personalizados"
            })

            this.clickHandler('customFields')
            /**
             * a atribuição de valor abaixo foi comentada pois para o customFields é redundante esta verificação,
             * visto que os dados selecionados sao enviados como um objeto inteiro pelo evento de $emit.
             */
            // fields = this.customFieldOptions.filter(option => fields.includes(option.value))
            this.inputHandler(fields)
        },
        /**
         * Event handler que trata o evento de quando um filtro é utilizado
         */
        clickHandler(fieldName) {
            this.fieldName = fieldName
        },
        /**
         * Executa quando o evento 'selected' do <ui-date-range> é emitido ($emit)
         * passando um objeto que contém a data selecionada(string) e o nome do
         * campo que emitiu o evento.
         * Esse nome é usado como Key para salvar a data na localStorage.
         *
         * Exemplo do dado salvo na localStorage:
         *      { "Data de Atualização": "2023-06-21_2023-06-21" }
         */
        selectedHandler(data) {
            const storageKey = `${this.reportCardCategory}_card_field_range_${this.reportCardIndex}`
            const storageDateRange = storage.get(storageKey) || '{}'
            const storageData = JSON.parse(storageDateRange)
            const newData = { ...storageData,  [data.fieldName]: data.value }

            storage.set(storageKey, JSON.stringify(newData))
            this.fieldName = data.fieldName
            this.inputHandler([data.value])
        },
        /**
         * Soma a quantidade dos campos selecionados e salva no localStorage
         */
        saveFields() {
            this.fieldsSelected[this.reportCardIndex] = Object.values(this.fieldsSelected[this.reportCardIndex]).filter(field => {
                return this.$mx_hasValue(field.fields)
            })
            const valueToSave = JSON.stringify(this.fieldsSelected[this.reportCardIndex])
            const storageName = `${this.reportCardCategory}_card_fields_${this.reportCardIndex}`

            storage.set(storageName, valueToSave)
            this.$root.$emit(`${this.reportCardCategory}-save-fields-${this.reportCardIndex}`)

            return this.fieldsSelected[this.reportCardIndex]
        },
        /**
         * Pega as seleções do usuário e solicita a geração do contrato
         */
        generateReport: async function () {
            const allFields = this.saveFields()
            // Verifica se já existe uma versão deste relatório em processo de geração
            const index = allFields.findIndex(item => item.fieldName === 'generating_file')
            let report = null

            try {
                this.$root.$emit('modal-open-download-csv-xlsx')
                if (index >= 0) {
                    report = { ...allFields[index] }

                } else {
                    // Formata os dados do localStorage para gerar o relatório requerido
                    let fields = []
                    let filters = []
                    let customFields = []
                    allFields.forEach(item => {
                        if (item.fieldName === 'general') {
                            fields = item.fields

                        } else if (item.fieldName === 'customFields') {
                            customFields = item?.fields?.map(field => {
                                return {
                                    id: field.id,
                                    alias: field.alias,
                                    custom: field.custom,
                                    group: field.group
                                }
                            })

                        } else {
                            const filter = this.filterOptions.find(filter => filter.name.trim() === item.fieldName.trim())
                            if (filter) {
                                const name = filter.label
                                const value = item.fields.map(value => value?.id || value)
                                filters.push({ name, value })
                            }
                        }
                    })
                    //Até aqui os filtros estão corretos
                    const reportData = JSON.parse(storage.get('report_data'))
                    const params = { ...reportData, fields, filters, customFields }

                    /**
                    * Determina se a requisição será feita no Data Lake com base na instância da empresa.
                    */
                    const getStorage = JSON.parse(storage.get('api_config'))
      			    const instance = getStorage.instance
                    const reportsCategoryInstance = await reportsCategory.defineVersionReports(instance)
                    const response = await reportsCategoryInstance.createV2('create', params)

                    report = {
                        name: response?.data?.data?.reportName,
                        csv: {
                            query_id: null,
                            url: ''
                        },
                        xls: {
                            job_id: null,
                            url: ''
                        },
                        status: 'generating'
                    }

                    if (response?.data?.data?.csvUrl) {
                        report.csv.url = response?.data?.data?.csvUrl
                        report.status = 'generated'

                    } else {
                        report.csv.query_id = response?.data?.data?.queryExecId
                    }
                    storage.set(
                        `${this.reportCardCategory}_card_fields_${this.reportCardIndex}`,
                        JSON.stringify([...allFields, { fieldName: 'generating_file', report }])
                    )

                    this.$root.$emit(`${this.reportCardCategory}-save-fields-${this.reportCardIndex}`)
                }
                this.$root.$emit(
                    'download-csv',
                    report,
                    { category: this.reportCardCategory, index: this.reportCardIndex }
                )

            } catch (error) {
                if (error.data && error.data.msg) {
                    this.$toastr.e(error.data.msg)

                } else {
                    this.$toastr.e('Falha ao gerar o contrato!')
                }
                this.$root.$emit('modal-close-download-csv-xlsx')
            }
        },
        /**
         * Limpa os dados do formulário
         */
        clearForm() {
            this.fieldsSelected[this.reportCardIndex] = []
            this.form.data.general_field[this.reportCardIndex] = []
            this.form.data.custom_field[this.reportCardIndex] = []
            this.form.data.date_range[this.reportCardIndex] = {}
            this.form.data.filters_data[this.reportCardIndex] = {}

            for (const filterName of ['status', 'gerente', 'corretor']) {
                const index = this.allFilters.findIndex(filter => {
                    return filter.name === filterName
                })
                if (index >= 0) {
                    this.allFilters[index].options = []
                    this.allFilters[index].params.value = null
                    this.allFilters[index].disabled = true
                    this.allFilters[index].alreadyRequested = false
                }
            }
        },
        /**
         * Limpa os campos selecionados e o localStorage
         */
        clearFields() {
            this.$gtm.trackEvent({
                event: "fac_button_click",
                category: "vue-relatorio-planilhas-new",
                action: "click",
                label: "Limpar Campos"
            })

            this.clearForm()
            this.$root.$emit(`${this.reportCardCategory}-clear-fields-${this.reportCardIndex}`)
            this.disable = true
        },
        /**
         * Handler para tratar o evento de quando uma equipe for selecionada, de modo
         * a carregar os gerentes desta equipe
         */
        teamHandler(value) {
            if (!value) return
            const index = this.allFilters.findIndex(filter => filter.name === 'gerente')
            this.allFilters[index].loading = true
            team.getManagersByTeam(value)
                .then(response => {
                    this.allFilters[index].loading = false
                    this.allFilters[index].options = response.data
                    this.allFilters[index].disabled = !response.data?.length
                    this.form.data.filters_data[this.reportCardIndex]['gerente'] = null

                    this.clickHandler('equipe')
                    this.inputHandler([value])
                })
                .catch(error => {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    console.log(error)
                })
        },
        /**
         * Handler para tratar o evento de quando um gerente for selecionado, de modo
         * a carregar os corretores pelos quais este é responsável
         */
        managerHandler(value) {
            if (!value) return
            const index = this.allFilters.findIndex(filter => filter.name === 'corretor')
            this.allFilters[index].loading = true
            team.getBrokersByManager(value)
                .then(response => {
                    this.allFilters[index].loading = false
                    this.allFilters[index].options = response.data
                    this.allFilters[index].disabled = !response.data?.length
                    this.form.data.filters_data[this.reportCardIndex]['corretor'] = null

                    this.clickHandler('gerente')
                    this.inputHandler([value])
                })
                .catch(error => {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    console.error(error)
                })
        },
        /**
         * Event handler que trata o evento de quando um corretor é selecionado no filtro
         */
        brokerHandler(value) {
            this.clickHandler('corretor')
            this.inputHandler([value])
        },
        /**
         * Chama dinamicamente um handler para tratar o evento do filtro
         */
        call(handler, event) {
            if (handler) this[handler](event)
        },
        /**
         * Event handler que trata o evento de quando uma Fila de Distribuição de Leads for
         * selecionado no filtro
         */
        leadHandler(value){
            this.clickHandler('fila_de_distribuicao_de_leads')
            this.inputHandler(value)
        },
        /**
         * Event handler que trata o evento de quando um Status da Reserva for
         * selecionado no filtro
         */
         statusReserveHandler(value){
            this.clickHandler('status_da_reserva')
            this.inputHandler(value)
        },
        /**
         * Event handler que trata o evento de quando uma opção de fila da Oferta Ativa é
         * selecionada
         */
        queuesHandler(value){
            this.clickHandler('queue_id')
            this.inputHandler(value)
            const reasonsFilter = this.filterOptions.find(filter => filter.params.name === 'reasons_id')
            reasonsFilter.disabled = true

            if (!value) {
                this.clickHandler('queue_id')
                this.inputHandler([])
                return
            }

            activeOffer.getQueueReasons(value)
                .then(response => {
                    // Seta as novas opções de filtragem de Reação
                    reasonsFilter.options = response.data
                    reasonsFilter.disabled = false
                    this.clickHandler('queue_id')
                    this.inputHandler([value])
                })
        },
        reasonsHandler(fields){
            if (!fields) return
            this.clickHandler('reacao')
            this.inputHandler(fields)
        },
        /**
         * Event handler para tratar o evento de quando o filtro de tipo de entrada de lead
         * é utilizado
         */
        leadEntryHandler(value) {
            this.clickHandler('tipo_de_entrada_do_lead')
            this.inputHandler(value)
        },
        /**
         * Event handler que trata o evento de quando um Status do Lead é selecionado nos filtros dinamicos
         */
        leadStatusHandler(fields) {
            this.clickHandler('status_do_lead')
            this.inputHandler(fields)
        },
        /**
         * Event handler que trata o evento de quando uma etapa é selecionada no filtro
         * de etapas
         */
        stageHandler(event) {
            // Busca os filtros de etapa e status
            const stageFilter = this.filterOptions.find(filter => filter.params.name === 'funnel_stage_id')
            const statusFilter = this.filterOptions.find(filter => filter.params.name === 'funnel_stage_status_id')

            // Filtra as opções de status, a partir da seleção de etapas, caso haja
            let statusOptions = []
            if (this.$mx_hasValue(event)) {
                statusOptions = stageFilter?.options
                    .filter(option => event.includes(option.id))
                    .map(option => option.status)
                    .reduce((acc, options) => acc.concat(options), [])
            }

            this.clickHandler('etapa')
            this.inputHandler(event)

            if (!this.$mx_hasValue(event)) {
                this.form.data.filters_data[this.reportCardIndex]['status'] = []
                statusFilter.params.value = null

            } else {
                // Remove as seleções de status cujas etapas foram deselecionadas
                const statusIds = statusOptions.map(option => option.id)
                const selecteds = this.form.data.filters_data[this.reportCardIndex]['status']?.filter(id => {
                    return statusIds.includes(id)
                })
                this.form.data.filters_data[this.reportCardIndex]['status'] = selecteds
                statusFilter.params.value = selecteds
            }
            statusFilter.options = [...statusOptions]
            statusFilter.alreadyRequested = true
            statusFilter.disabled = !statusOptions.length || !this.$mx_hasValue(event)
        },
        /**
         * Event handler que trata o evento de quando um status é selecionado no filtro
         * de Status
         */
        statusHandler(event) {
            this.clickHandler('status')
            this.inputHandler(event)
        }
    }
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>